import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  makeStyles,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@material-ui/core'

import moment from 'moment'

import { useDispatch, useSelector } from 'react-redux'
import { Creators as AnalitycalPartsActions } from '~/store/ducks/analitycalParts'
import { useMobileScreen } from '~/helpers/useMediaQuery'
import { formatPrice } from '~/helpers/masks'
import ShowHideColumns from '~/components/ShowHideColumns'
import styles from './styles'

const analitycalPartsSelector = ({ analitycalParts }) => analitycalParts

const useStyles = makeStyles(styles)

const AnalitycalPartsDialog = ({ open, onClose, type }) => {
  const classes = useStyles()
  const isMobileScreen = useMobileScreen()
  const dispatch = useDispatch()
  const { dataDetails, showHideColumnsDialog } = useSelector(
    analitycalPartsSelector,
  )

  useEffect(() => {
    if (open) {
      dispatch(AnalitycalPartsActions.getAnalitycalPartsDetailsRequest(type))
    }
  }, [type])

  const getColorTableCellProfit = (item) => {
    return item.profit < 0 ? 'red' : 'black'
  }

  const getColorTableCellProfitPorcentage = (item) => {
    return item.profit_percentage < 0 ? 'red' : 'black'
  }

  const optionsShowHideColumnDialog = [
    { name: 'emissao', label: 'Data' },
    { name: 'amount', label: 'Quantidade' },
    { name: 'billing', label: 'Faturamento' },
    { name: 'cost', label: 'Custo' },
    { name: 'liquidValue', label: 'Lucro' },
    { name: 'porcentage', label: '%' },
  ]

  const handleSetChangeShowHideColumn = (name, value) => {
    const newColumnsTable = {
      ...showHideColumnsDialog,
      [name]: value,
    }

    dispatch(
      AnalitycalPartsActions.setChangeShowHideColumnsAnalitycalPartsDialog(
        newColumnsTable,
      ),
    )
  }

  const titleDialog = () => {
    if (type === 'atacado') {
      return 'Atacado'
    }
    if (type === 'balcao') {
      return 'Balcão'
    }

    return 'Oficina'
  }

  return (
    <Dialog
      fullScreen={isMobileScreen}
      fullWidth
      maxWidth="md"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.paper }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h3">Peças - {titleDialog()}</Typography>
      </DialogTitle>
      <Divider className={classes.divider} />
      <DialogContent className={classes.dialogContent}>
        <Table stickyHeader size="small" className={classes.table}>
          <TableHead>
            <TableRow>
              {showHideColumnsDialog.emissao && (
                <TableCell align="center">Data</TableCell>
              )}
              {showHideColumnsDialog.amount && (
                <TableCell align="center">Quantidade</TableCell>
              )}
              {showHideColumnsDialog.billing && (
                <TableCell align="left">Faturamento</TableCell>
              )}
              {showHideColumnsDialog.cost && (
                <TableCell align="center">Custo</TableCell>
              )}
              {showHideColumnsDialog.liquidValue && (
                <TableCell align="center">Lucro </TableCell>
              )}
              {showHideColumnsDialog.porcentage && (
                <TableCell align="center">%</TableCell>
              )}
              <TableCell>
                <ShowHideColumns
                  showHideColumns={showHideColumnsDialog}
                  optionsShowHideColumn={optionsShowHideColumnDialog}
                  onChangeShowHideColumn={handleSetChangeShowHideColumn}
                />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataDetails.map((item) => (
              <TableRow hover className={classes.tableRow} key={item.family}>
                {showHideColumnsDialog.emissao && (
                  <TableCell align="center">
                    {moment(item.emissao).format('DD/MM/YYYY') || '-'}
                  </TableCell>
                )}
                {showHideColumnsDialog.amount && (
                  <TableCell align="center">{item.amount || '-'}</TableCell>
                )}
                {showHideColumnsDialog.billing && (
                  <TableCell align="left">
                    {formatPrice(Number(item.revenues))}
                  </TableCell>
                )}
                {showHideColumnsDialog.cost && (
                  <TableCell align="center">
                    {formatPrice(Number(item.cost))}
                  </TableCell>
                )}
                {showHideColumnsDialog.liquidValue && (
                  <TableCell
                    style={{
                      color: getColorTableCellProfit(item),
                    }}
                    align="center"
                  >
                    {formatPrice(Number(item.profit)) || '-'}
                  </TableCell>
                )}
                {showHideColumnsDialog.porcentage && (
                  <TableCell
                    align="center"
                    style={{
                      color: getColorTableCellProfitPorcentage(item),
                    }}
                  >
                    {`${parseFloat(item.profit_percentage || 0).toFixed(2)}%` ||
                      '-'}
                  </TableCell>
                )}
                <TableCell />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <Divider className={classes.divider} />
      <DialogActions className={classes.buttonForm}>
        <Button onClick={onClose} variant="contained">
          FECHAR
        </Button>
      </DialogActions>
    </Dialog>
  )
}

AnalitycalPartsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string,
}

AnalitycalPartsDialog.defaultProps = {
  type: null,
}

export default AnalitycalPartsDialog
